import { useContext, useState, useEffect } from "react";
import { useRouter } from "next/router";
import { DropZoneBig } from "../dropZone";
import VideoUpload from "../videoUpload";
import { GlobalContext } from "../../../stores/use_global_state";
import BoldMenu from "../BoldMenu/BoldMenu";
import UploadProgress from "../ProgressBar/UploadProgress";
import MainBlob from "../../animate/MainBlob";

function UploadFileScreen({ trim_start, trim_duration, uploadFile, uploadedProgress, delFile, dictionary, style, isTrim, pageType = "", showModalCallback }) {
	const { state } = useContext(GlobalContext);

	const [progress, setProgress] = useState(0);
	const router = useRouter();

	const backBtnHandler = () => {
		if (state?.video) {
			delFile();
		} else {
			router.push("/");
		}
	};

	useEffect(
		() => {
			if (uploadedProgress !== null && 100 >= uploadedProgress) {
				setProgress(Math.floor(uploadedProgress * 0.8));
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[uploadedProgress]
	);

	useEffect(
		() => {
			if (state.task?.output_type === "preview") {
				const notionalInterest = () => {
					setProgress(progress + 1);
				};

				if (progress < 95) {
					notionalInterest();
				}

				if (state.task?.status === "done") {
					setProgress(100);
				}
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[state.task]
	);

	return (
		<>
			<BoldMenu dictionary={dictionary} btn={state?.video ? ["back"] : []} onBackBtn={backBtnHandler} pageTitle={pageType} />

			<div className={style.wrapper}>
				{state?.video ? (
					<VideoUpload progress={progress} trim_duration={trim_duration} trim_start={trim_start} delFile={delFile} style={style} isTrim={isTrim} dictionary={dictionary} />
				) : (
					<DropZoneBig style={style} uploadFile={uploadFile} pageType={pageType} errorStatus={state.error_msg || state.error_code} showModalCallback={showModalCallback} />
				)}

				{!state.video && pageType === "turn" && (
					<div className={style.rightBack}>
						<div className={style.right}>
							<div className={style["turn-page-block"]}>
								<h2 className={` ${style.info} ${style["plan-title"]}`}>{dictionary["Create video from your photo"] || "Create video from your photo"}</h2>
								<p className={style["turn-page-description"]}>{dictionary["Add video background to your photo"]}</p>
							</div>
						</div>
					</div>
				)}
				<MainBlob isBack={true} />
			</div>
			{state.video && <UploadProgress progress={progress} dictionary={dictionary} isAdaptive={false} />}
		</>
	);
}

export default UploadFileScreen;
